import { styled } from '@linaria/react';
import { fonts, radius, semantic, size, space } from '../../theme/tokens';

export const Bar = styled.div`
  display: inline-flex;
  align-items: center;
  background: ${semantic.bg.surfaceSubtle};
  border-radius: ${radius('input', 'radius-full')};
  min-height: ${space['space-1000']};
`;

export const Pill = styled.button`
  display: inline-flex;
  align-items: center;
  gap: ${space['space-300']};
  font-family: ${fonts.body};
  font-size: ${fonts.size.md};
  font-weight: ${fonts.weight.medium};
  color: ${semantic.text.primary};
  background: transparent;
  border: none;
  border-radius: ${radius('input', 'radius-full')};
  padding: ${space['space-300']} ${space['space-600']};
  cursor: pointer;
  white-space: nowrap;
  transition: font-weight 0.1s ease;

  &:hover {
    font-weight: ${fonts.weight.semiBold};
  }

  &:focus-visible {
    outline: ${size.stroke['stroke-thick']} solid ${semantic.border.selected};
    outline-offset: calc(-1 * ${size.stroke['stroke-thick']});
  }

  &[disabled] {
    cursor: default;
  }
`;

export const DotSeparator = styled.span`
  color: ${semantic.text.tertiary};
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  pointer-events: none;
`;

export { PillLabel } from './JourneyPicker.styles';
